export default __webpack_public_path__ + "static/media/Price-pic.9fe13527.png";